import { render, staticRenderFns } from "./InnerWindow.vue?vue&type=template&id=3fc628f0&scoped=true"
import script from "./InnerWindow.vue?vue&type=script&lang=js"
export * from "./InnerWindow.vue?vue&type=script&lang=js"
import style0 from "./InnerWindow.vue?vue&type=style&index=0&id=3fc628f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc628f0",
  null
  
)

export default component.exports